import { createContext } from 'react';
import { FlowValidationIssue } from '../../Models/FlowSaveError';

export const FlowValidationContext = createContext<ReadonlyMap<string, FlowValidationIssue[]>>(new Map());
